import { Box, Stack, styled } from "@mui/material";

export const SummaryItem = styled(Box)<{ light?: boolean }>(({ theme, light = false }) => ({
    backgroundColor: light ? theme.palette.background.default : theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    overflow: 'hidden',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    margin: theme.spacing(0.6),
    padding: theme.spacing(1.2),
    paddingBottom: theme.spacing(0.4),
    cursor: 'pointer',
    transition: 'all 0.2s',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: theme.shadows[4]
    },
}));

export const SummaryInfo = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    paddingRight: theme.spacing(2),
    '& > :first-of-type': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: theme.typography.body2.fontSize,
        fontWeight: theme.typography.body2.fontWeight,
    }
}))

export const SummaryFooter = styled(Stack)<{ paddingY?: number }>(({ theme, paddingY = 0.4 }) => ({
    fontSize: theme.typography.caption.fontSize,
    padding: theme.spacing(paddingY, 0),
    alignItems: 'center',
    flexDirection: 'row',
}));

export const SummaryDetail = styled(Box)<{ justifyContent?: string }>(({ 
    theme, justifyContent = 'flex-start' }) => ({
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    width: 'auto',
    justifyContent: justifyContent,
    overflow: 'hidden',
    fontWeight: 'lighter',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // Link type child
    '& a': {
        color: theme.palette.primary.main,
        textDecoration: 'none'
    }
}));
